import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { matchPath, useLocation, useNavigate } from 'react-router';
import { sortLinksFunction } from '../../../utils/layout-utils';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function PresetLink({ prop }) {
  const {
    className = '', name = '', afterContent = null, path = '', children = [],
  } = prop;
  const [isOpenGroup, setIsOpenGroup] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { formatMessage } = useIntl();
  const isActive = (location.pathname + location.search) === path || (location.search && path.includes(location.search));
  const isChildren = Boolean(children && children.length);
  const isChildrenActive = children.reduce((acc, current) => acc || (location.pathname + location.search) === current.path || (location.search && current.path.includes(location.search)), false);
  return (
    <div className={classNames('bd-toc-item', className)}>
      <div className="menu-link-block">
        <div
          className={classNames('menu-link preset-link', className, { active: isActive || isChildrenActive })}
          onClick={() => navigate(path)}
        >
          <span className="nav-link-text">{formatMessage({ id: name })}</span>
        </div>
        {afterContent || null}
        {isChildren
            && (
              <div onClick={() => setIsOpenGroup(!isOpenGroup)} className="nested-arrow-wrapper ms-2"><Icons
                customIcon
                icon="arrow-down"
                className={classNames('nested-arrow', { open: isOpenGroup })}
                width={18}
                height={18}
              />
              </div>
            )}
      </div>
      <ul className={classNames('nav nested sub-nav-group', { show: isChildren && isOpenGroup })}>
        {children.sort(sortLinksFunction).map((prop, key) => <PresetLink key={key} prop={prop} />)}
      </ul>
    </div>
  );
}
